module.exports = __webpack_public_path__ + "img/_logo_showroomiris.22ec2a11.png";